<template lang="">
    <v-container fluid fill-height>
        <v-row>
            <v-col md="7">
                <v-icon>mdi-timer-outline</v-icon>
                {{titulo}}
            </v-col>
            <v-col md="2">
                <hmi-editable-number-input 
                    :valor="getValue(topic_hora)" 
                    :topic=topic_hora
                    unidades=""
                    @cambio="modificar"
                />:
                <hmi-editable-number-input 
                    :valor="getValue(topic_minuto)" 
                    :topic=topic_minuto
                    unidades=""
                    @cambio="modificar"
                />:
                <hmi-editable-number-input 
                    :valor="getValue(topic_segundo)" 
                    :topic=topic_segundo
                    unidades=""
                    @cambio="modificar"
                />
            </v-col>
            <v-col md="2">
                {{getValue(topic_dec_hora)}}:
                {{getValue(topic_dec_minuto)}}:
                {{getValue(topic_dec_segundo)}}
            </v-col>
            <v-col md="1">h:m:s</v-col>
        </v-row>
</v-container>
</template>
<script>
import HmiEditableNumberInput from '@/components/HMI/modulos/HmiEditableNumberInput.vue'
import { mapActions } from 'vuex'
export default {

    components: {
        HmiEditableNumberInput
    },

    props: {
        titulo: String,
        topic_hora: String,
        topic_minuto: String,
        topic_segundo: String,
        datos: Object,

        topic_dec_hora: String,
        topic_dec_minuto: String,
        topic_dec_segundo: String,
    },

    methods: {

        ...mapActions("nodered",['doPublish']),
        getValue(nombre) {
            if (nombre) {
                return this.datos[nombre]
            } else return '?'
        },

        //escribir en MQTT
        // escribir(payload) {
        //     const publication = {
        //         topic: payload.topic,
        //         qos: 2,
        //         payload: JSON.stringify({ 'valor': payload.valor }),
        //     }
        //     this.doPublish(publication)
        // },

        modificar(payload){
            const payload2={
                'valor':payload.valor,
                'topic':payload.topic
            }
            this.$emit('cambio', payload2)
        },
    },

}
</script>
<style lang="">
    
</style>